export const FormData = {
  hours: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ],
  minutes: ["00", "15", "30", "45"],
  ampm: ["AM", "PM"],
  timezones: [
    "Pacific Time",
    "Australia Eastern Time",
    "British Time",
    "Central European Time",
    "Greenwich Mean Time",
    "India Standard Time",
  ],

  timezoneOptions: [
    { key: "PT", name: "Pacific Time" },
    { key: "AET", name: "Australia Eastern Time" },
    { key: "BT", name: "British Time" },
    { key: "CET", name: "Central European Time" },
    { key: "GMT", name: "Greenwich Mean Time" },
    { key: "IST", name: "India Standard Time" },
  ],

  /* eventSeries is used to map to eventImage in formHelper.js -- If you change this list, double check that list. */
  eventSeries: [
    "Analytics Champions",
    "AEM Champions",
    "Adobe Developers Live",
    "AEM Gems",
    "Coffee Break",
    "Community Event",
    "Customer Workshop",
    "Experience Cloud Tech Sessions",
    "Experience League LIVE",
    "GenStudio for Performance Marketing Events",
    "Learn from your peers",
    "Livestream",
    "Marketo Champions",
    "Q&A chat",
    "Skill Builders",
    "Skill Exchange",
    "Webinar",
  ],

  products: async () => {
    let labels = [];
    let page = 1;
    let hasNextPage = true;
    while (hasNextPage) {
      let response = await fetch(`https://experienceleague.adobe.com/api/v2/taxonomy?taxonomyType=product&lang=en&page=${page}&pageSize=100`);
      let json = await response.json();
      labels.push(...json.data.map((item) => item.displayLabel));
      hasNextPage = json.pagination.hasNextPage;
      page++;
    }
    return [...new Set(labels)].sort();
  },
   
  ctaLabels: ["Register", "Learn More", "Join Now"],
};

export function withKey(array) {
  return (array || []).map((item) => {
    return { key: item };
  });
}
